import { CompanyDepartment } from "@/graphql/codegen/graphql"

export const COMPANY_DEPARTMENT_LABEL_MAP = {
  [CompanyDepartment.Accounting]: "Accounting",
  [CompanyDepartment.AccountsPayable]: "Accounts Payable",
  [CompanyDepartment.AccountsReceivable]: "Accounts Receivable",
  [CompanyDepartment.CustomerService]: "Customer Service",
  [CompanyDepartment.Ehs]: "EHS",
  [CompanyDepartment.Engineering]: "Engineering",
  [CompanyDepartment.Executive]: "Executive",
  [CompanyDepartment.HumanResources]: "Human Resources",
  [CompanyDepartment.Inventory]: "Inventory",
  [CompanyDepartment.Lab]: "Lab",
  [CompanyDepartment.Logistics]: "Logistics",
  [CompanyDepartment.Management]: "Management",
  [CompanyDepartment.Procurement]: "Procurement",
  [CompanyDepartment.Purchasing]: "Purchasing",
  [CompanyDepartment.QualityAssurance]: "Quality Assurance",
  [CompanyDepartment.ResearchAndDevelopment]: "Research And Development",
  [CompanyDepartment.Sales]: "Sales",
  [CompanyDepartment.Technical]: "Technical",
  [CompanyDepartment.TechnicalSupport]: "Technical Support",
}
